import { createStructuredSelector } from 'reselect'

import {
   AWARD_LIST,
   AWARD_LIST_SUCCESS, 
   AWARD_LIST_ERROR,
   AWARD_PAGE_SET,
   AWARD_SEARCH_SET,
   AWARD_SEARCH_CHANGE,
   AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT,
   AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   AWARD_ADD_SET,
   AWARD_ADD_MODAL_SET,
   AWARD_ADD,
   AWARD_ADD_SUCCESS,
   AWARD_ADD_ERROR,
   AWARD_ADD_CHANGE,
   AWARD_DETAIL,
   AWARD_DETAIL_SUCCESS,
   AWARD_DETAIL_ERROR,
   AWARD_VIEW_MODAL_SET,
   AWARD_EDIT_CHANGE,
   AWARD_EDIT_MODAL_SET,
   AWARD_UPDATE,
   AWARD_UPDATE_SUCCESS,
   AWARD_UPDATE_ERROR,
   AWARD_VIEW_TAB_SET,
   AWARD_UPLOAD_SET,
   AWARD_UPLOAD_SET_SUCCESS,
   AWARD_UPLOAD_SET_ERROR,
   AWARD_UPLOAD_RESET
} from '../actions';

export const AWARD_NAME = 'award';
const NAME = AWARD_NAME;

export const AwardList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  AWARD_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AwardListSuccess = (data) => ({
  type:  AWARD_LIST_SUCCESS,
  payload: data
});

export const AwardListError = (error) => ({
  type:  AWARD_LIST_ERROR,
  payload: error
});

export const AwardPageSet = (data) => ({
  type:  AWARD_PAGE_SET,
  payload: data
});

export const AwardSearchSet = (data) => ({
  type:  AWARD_SEARCH_SET,
  payload: data
});

export const AwardSearchChangeSet = (data) => ({
  type:  AWARD_SEARCH_CHANGE,
  payload: data
});

export const AwardSearchDeliveryOrderLineLot = (data) => ({
  type:  AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const AwardSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const AwardSearchDeliveryOrderLineLotError = (error) => ({
  type:  AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const AwardAddChangeSet = (data) => ({
  type:  AWARD_ADD_CHANGE,
  payload: data
});

export const AwardAddSet = (data) => ({
  type:  AWARD_ADD_SET,
  payload: data
});

export const AwardAddModalSet = (data) => ({
  type:  AWARD_ADD_MODAL_SET,
  payload: data
});

export const AwardAdd = (data) => ({
  type:  AWARD_ADD,
  payload: data
});

export const AwardAddSuccess = (message) => ({
  type:  AWARD_ADD_SUCCESS,
  payload: message
});

export const AwardAddError = (error) => ({
  type:  AWARD_ADD_ERROR,
  payload: error
});

export const AwardDetail = (data) => ({
  type:  AWARD_DETAIL,
  payload: data
});

export const AwardDetailSuccess = (data) => ({
  type:  AWARD_DETAIL_SUCCESS,
  payload: data
});

export const AwardDetailError = (error) => ({
  type:  AWARD_DETAIL_ERROR,
  payload: error
});

export const AwardViewModalSet = (data) => ({
  type:  AWARD_VIEW_MODAL_SET,
  payload: data
});

export const AwardEditModalSet = (data) => ({
  type:  AWARD_EDIT_MODAL_SET,
  payload: data
});

export const AwardEditChangeSet = (data) => ({
  type:  AWARD_EDIT_CHANGE,
  payload: data
});

export const AwardUpdate = (data) => ({
  type:  AWARD_UPDATE,
  payload: data
});

export const AwardUpdateSuccess = (message) => ({
  type:  AWARD_UPDATE_SUCCESS,
  payload: message.message
});

export const AwardUpdateError = (error) => ({
  type:  AWARD_UPDATE_ERROR,
  payload: error
});

export const AwardViewTabSet = (data) => ({
  type:  AWARD_VIEW_TAB_SET,
  payload: data
});

export const AwardUploadSet = (file) => ({
  type:  AWARD_UPLOAD_SET,
  payload: { file },
});

export const AwardUploadSetSuccess = (items) => ({
  type:  AWARD_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const AwardUploadSetError = (error) => ({
  type:  AWARD_UPLOAD_SET_ERROR,
  payload: error,
});

export const AwardUploadReset= () => ({
  type:  AWARD_UPLOAD_RESET
});

const award = (state) => state[NAME];

export const AwardSelector = createStructuredSelector({
  award
})
 